// AcidIsland page entry — direct mount without shared-ui CSS.
// acidisland.css is loaded via <link> in the HTML template.
import { createRoot } from "react-dom/client";
import { AcidIslandPage } from "../pages/AcidIslandPage";

const rootEl = document.getElementById("root");
if (rootEl === null) {
  throw new Error("acidisland entry: #root container missing in index.html");
}
createRoot(rootEl).render(<AcidIslandPage />);
